import React from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiZap } = FiIcons;

export default function Footer() {
  return (
    <footer className="bg-white border-t border-slate-100 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between items-center mb-12">
          <div className="flex items-center gap-2 mb-4 md:mb-0">
            <SafeIcon icon={FiZap} className="h-6 w-6 text-blue-600" />
            <span className="font-bold text-xl text-slate-900">SwitchFree</span>
          </div>
          <div className="flex space-x-6">
            <Link to="/how-it-works" className="text-slate-500 hover:text-slate-900">How it Works</Link>
            <Link to="/auth" className="text-slate-500 hover:text-slate-900">Sign In</Link>
            <a href="#" className="text-slate-500 hover:text-slate-900">Privacy</a>
            <a href="#" className="text-slate-500 hover:text-slate-900">Terms</a>
          </div>
        </div>
        <div className="text-center text-slate-400 text-sm">
          &copy; {new Date().getFullYear()} SwitchFree Inc. All rights reserved. Bank-level security.
        </div>
      </div>
    </footer>
  );
}